import { AssignmentReportTypeEnum } from "../assignments/const";
import { StudentExportTypeEnum } from "../students/const";

export enum ExportTypeEnum {
  Parent = "parents",
  CommercialDocument = "commercialDocuments",
  StudentRenewal = "studentRenewals",
  CcaStudentRenewal = "ccaStudentRenewals",
}

export const exportTypeList = [
  {
    id: ExportTypeEnum.Parent,
    name: "Parent Data",
  },
  {
    id: StudentExportTypeEnum.Student,
    name: "Student Data",
  },
  {
    id: StudentExportTypeEnum.StudentMasterList,
    name: "Student Master List",
  },
  {
    id: AssignmentReportTypeEnum.AreaReport,
    name: "Assignment Area Report",
  },
  {
    id: AssignmentReportTypeEnum.PassengerReport,
    name: "Assignment Passenger Report",
  },
  {
    id: AssignmentReportTypeEnum.AmBusArrivalReport,
    name: "Assignment AM Bus Arrival Report",
  },
  {
    id: AssignmentReportTypeEnum.AssignmentSummaryReport,
    name: "Assignment Summary Report",
  },
  {
    id: ExportTypeEnum.CommercialDocument,
    name: "Commercial Document Data",
  },
  {
    id: ExportTypeEnum.StudentRenewal,
    name: "Regular Student Renewal Data",
  },
  {
    id: ExportTypeEnum.CcaStudentRenewal,
    name: "CCA Student Renewal Data",
  },
];
